/**
 * Rutas de ai — ARIA: home, bandeja, actividad, asistente y conversaciones.
 *
 * Se componen en `src/pages/index.jsx`. Es un fragmento, no un array: React Router
 * recorre los `<React.Fragment>` hijos de `<Routes>`, así que el JSX se mudó tal cual
 * —sin `key` ni comas— y el diff es el movimiento, nada más.
 *
 * `routeTable.test.jsx` congela las 174 rutas de la app contra la tabla previa a la
 * mudanza: perder una ruta aquí no da error, da un 404.
 */
import { Route, Navigate } from 'react-router-dom';
import { lazyWithRetry } from '@/lib/lazyWithRetry';
import { AriaHome } from '@/pages/routeHelpers';
import { PermissionGuard } from '@/components/auth/PermissionGuard';
import { PERMS } from '@/constants/permissions';

const AsistenteAgentic = lazyWithRetry(() => import("@/pages/AsistenteAgentic"));
const BandejaAria = lazyWithRetry(() => import("@/pages/BandejaAria"));
const AIConversationsDashboard = lazyWithRetry(() => import("@/pages/AIConversationsDashboard"));

export const routes = (
  <>
                <Route path="/aria-home" element={<AriaHome />} />

                <Route path="/aria/bandeja" element={<BandejaAria />} />

                {/* Consolidada en la lente del hub de Contabilidad.
                    Había TRES entradas a «Actividad de ARIA» y ésta era la más
                    pobre: solo el feed, sin el «por qué ARIA no contabiliza
                    sola», sin el parte diario firmable y sin el dial. Quien
                    llegaba desde el chip del pulso veía la lista y ninguna
                    explicación — y la explicación estaba a dos clics, en otra
                    pantalla.
                    Se redirige en vez de borrar la ruta: el chip del pulso y
                    cualquier enlace guardado siguen funcionando. Mismo patrón
                    que `/analytics` → `/insights` en platform/routes.jsx. */}
                <Route path="/aria/actividad" element={<Navigate to="/accounting/autopilot" replace />} />


                {/* AI & Agentic */}
                <Route path="/asistente-agentic" element={
                  <PermissionGuard permission={PERMS.AI_USE} fallback={<Navigate to="/" replace />}>
                    <AsistenteAgentic />
                  </PermissionGuard>
                } />

                {/* Block 1C — revisión admin de conversaciones de ARIA (PII → roles.manage; backend revalida admin/owner) */}
                <Route path="/ai-conversations" element={
                  <PermissionGuard permission={PERMS.ROLES_MANAGE} fallback={<Navigate to="/" replace />}>
                    <AIConversationsDashboard />
                  </PermissionGuard>
                } />
  </>
);
